var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 12"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8.617 8.793L7.91 9.5 4.375 5.964 7.91 2.43l.707.707L5.79 5.964l2.828 2.829z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }